import ActionLog from "../Components/ActionLog/ActionLog";

const ActionLogPage = () => {
  return <ActionLog />;
};

export default ActionLogPage;
